// extracted by mini-css-extract-plugin
module.exports = {"container":"Animation_container__1S6y1"};